/* src/app/webhook-creator/webhook-creator/webhook-log/webhook-log.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  width: 100%;
  padding-top: 20px;
}
.content {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.timeline-custom {
  padding-left: 20px;
}
.header-log-result-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}
.toolbar-log-result {
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
  height: 22px;
  justify-content: space-between;
  align-items: center;
}
.log-result-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 10px;
  gap: 10px;
}
.text-block {
  word-break: break-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}
.log-filter-bar {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: right;
}
.timeline-custom-detail {
  display: flex;
  justify-content: space-between;
  align-items: end;
  width: 100%;
}
.card-board {
  margin-bottom: 8px;
}
/*# sourceMappingURL=webhook-log.component.css.map */
